import '@styles/Icon/size-one-icons.css'
import '@styles/TopBar/style.css'
import classNames from 'classnames'
import React, { ElementType, useCallback } from 'react'
import Icon from '../Icons'
import PopUp from '../Popup'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import Tooltip from '@material-ui/core/Tooltip'

interface ITypography {
  variant?: any
  color?: any
  class?: any
  disabled?: boolean
  showTooltip?: boolean
}

export interface IIcon {
  name: string
  image?: string
  text?: string
  onItemClick?: () => void
  isPopUp?: boolean
  popUpContent?: any
  popUpContentStyle?: React.CSSProperties
  popUpProps?: any
  showIcon?: boolean
  customElement?: any
  isCustomElement?: boolean
  typographyDetails?: ITypography
  customElementProps?: any
  disable?: boolean
  customClass?: any
  // @deprecated
  showIconRight?: boolean
  // @deprecated
  rightIconImage?: any
  // Serves as left icon primarily
  icon?: {
    element: ElementType
    props?: {
      size: number
    }
  }
  rightIcon?: {
    element: ElementType
    props?: {
      size: number
    }
  }
  tooltip?: string
  basePath?: string
}

export interface ITopBar {
  rightIcons?: IIcon[]
  leftIcons?: IIcon[]
  showLeftIcons?: boolean
  showRightIcons?: boolean
  rightIconsContainerCSS?: string
  leftIconsContainerCSS?: string
}

const TopBar: React.FC<ITopBar> = ({
  rightIcons,
  leftIcons,
  showLeftIcons = false,
  showRightIcons = true,
  rightIconsContainerCSS = '',
  leftIconsContainerCSS = ''
}) => {
  const getTypographyText = useCallback(
    (item, classVal, defaultVariant = 'captionDarkGrey') => {
      return (
        <Tooltip title={item?.typographyDetails?.showTooltip ? item.text : ''}>
          <div className={classVal ?? ''}>
            <Typography variant={item?.typographyDetails?.variant ?? defaultVariant}>
              {item.text}
            </Typography>
          </div>
        </Tooltip>
      )
    },
    []
  )

  return (
    <div className='top-bar'>
      {Boolean(leftIcons?.length) && showLeftIcons ? (
        <div className={classNames('left-icon', leftIconsContainerCSS)}>
          {leftIcons.map(item => {
            if (item.isCustomElement && item.showIcon) {
              const CustomElement = item.customElement
              return (
                <div className={'icon-container'} key={item.name}>
                  <CustomElement {...item.customElementProps} />
                </div>
              )
            } else if (item.isPopUp && item.showIcon) {
              const popupContent = item.popUpContent
              return (
                <div
                  key={item.name}
                  className={classNames({
                    disable: item?.disable
                  })}
                >
                  <PopUp
                    contentStyle={item?.popUpContentStyle}
                    trigger={
                      <div
                        className='icon-container'
                        style={item.showIconRight ? { flexDirection: 'row-reverse' } : {}}
                      >
                        <Icon
                          imageSrc={item.image}
                          alt={item.name}
                          className={'topbar-icon'}
                          onIconClick={item.onItemClick}
                        />
                        <div className={'text'}>
                          {getTypographyText(item, item?.typographyDetails?.class)}
                        </div>
                      </div>
                    }
                    {...item.popUpProps}
                  >
                    {popupContent}
                  </PopUp>
                </div>
              )
            } else if (item.showIcon) {
              return (
                <div
                  className={classNames('icon-container', item.customClass)}
                  key={item.name}
                  onClick={item.onItemClick}
                >
                  {item.image ? (
                    <Icon
                      imageSrc={item.image}
                      alt={item.name}
                      className={'topbar-left-icon'}
                    />
                  ) : null}

                  {getTypographyText(
                    item,
                    classNames('text', item?.typographyDetails?.class)
                  )}
                </div>
              )
            } else {
              return null
            }
          })}
        </div>
      ) : (
        <div></div>
      )}
      {rightIcons?.length && showRightIcons ? (
        <div className={classNames('right-icon', rightIconsContainerCSS)}>
          {rightIcons.map(item => {
            if (item.showIcon && item.isPopUp) {
              const popupContent = item.popUpContent
              return (
                <div
                  key={item.name}
                  className={classNames({
                    disable: item?.disable
                  })}
                >
                  <PopUp
                    contentStyle={item?.popUpContentStyle}
                    trigger={
                      <Tooltip title={item.tooltip || ''}>
                        <div
                          className={'icon-container'}
                          // style={item.showIconRight ? { flexDirection: 'row-reverse' } : {}}
                        >
                          {item.image ? (
                            <Icon
                              imageSrc={item.image}
                              alt={item.name}
                              onIconClick={item.onItemClick}
                            />
                          ) : item.icon ? (
                            <item.icon.element {...item.icon.props} />
                          ) : null}
                          {item.text ? getTypographyText(item, 'text') : null}
                          {item.showIconRight && (
                            <Icon
                              imageSrc={item.rightIconImage}
                              alt={item.name}
                              onIconClick={item.onItemClick}
                            />
                          )}
                        </div>
                      </Tooltip>
                    }
                    {...item.popUpProps}
                  >
                    {popupContent}
                  </PopUp>
                </div>
              )
            } else if (item.showIcon && item.isCustomElement) {
              const CustomElement = item.customElement
              return (
                <>
                  <Tooltip title={item.tooltip || ''}>
                    <div
                      className={classNames(
                        {
                          disable: item?.disable,
                          'icon-container': true
                        },
                        item.customClass
                      )}
                      key={item.name}
                    >
                      <CustomElement {...item.customElementProps} />
                    </div>
                  </Tooltip>
                </>
              )
            } else if (item.showIcon) {
              return (
                <Tooltip title={item.tooltip || ''}>
                  <div
                    className={classNames(
                      {
                        disable: item?.disable,
                        'icon-container': true
                      },
                      item.customClass
                    )}
                    key={item.name}
                    onClick={item.onItemClick}
                  >
                    {item.image ? (
                      <Icon
                        imageSrc={item.image}
                        alt={item.name}
                        onIconClick={item.onItemClick}
                      />
                    ) : item.icon ? (
                      <item.icon.element {...item.icon.props} />
                    ) : null}

                    {item.text
                      ? getTypographyText(
                          item,
                          classNames(
                            'text',
                            item?.typographyDetails?.disabled && 'disable'
                          )
                        )
                      : null}
                  </div>
                </Tooltip>
              )
            } else {
              return null
            }
          })}
        </div>
      ) : null}
    </div>
  )
}

export default TopBar
